// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3X3EO","title":"ClientInsurance_title__4IhkJ","itemText":"ClientInsurance_itemText__1Gd8d"};